import api from './api';

// Quotes — the anaesthetic estimate a patient accepts before surgery (informed
// financial consent). Staff calls need a login; the public ones are the patient's link.
const quoteService = {
  // view: awaiting | accepted | declined | expired | draft | all → { quotes, counts }
  list: ({ view = 'all', bid, patientId } = {}) =>
    api.get('/quotes', { params: { view, bid: bid || undefined, patient_id: patientId || undefined } }).then((r) => r.data),
  get: (id) => api.get(`/quotes/${id}`).then((r) => r.data.quote),
  // { bid, patient_id, codes, facts } → the estimate, nothing saved
  preview: (payload) => api.post('/quotes/preview', payload).then((r) => r.data.estimate),
  create: (payload) => api.post('/quotes', payload).then((r) => r.data),
  update: (id, payload) => api.put(`/quotes/${id}`, payload).then((r) => r.data),
  // → { quote, link, emailed, email_error }
  send: (id, email) => api.post(`/quotes/${id}/send`, { email: email || undefined }, { timeout: 60000 }).then((r) => r.data),
  cancel: (id) => api.post(`/quotes/${id}/cancel`).then((r) => r.data.quote),

  schemeRates: () => api.get('/quotes/scheme-rates').then((r) => r.data.rates || []),
  addSchemeRate: (payload) => api.post('/quotes/scheme-rates', payload).then((r) => r.data.rates || []),
  updateSchemeRate: (id, payload) => api.put(`/quotes/scheme-rates/${id}`, payload).then((r) => r.data.rates || []),
  removeSchemeRate: (id) => api.delete(`/quotes/scheme-rates/${id}`).then((r) => r.data.rates || []),

  publicLoad: (token) => api.get(`/public/quotes/${encodeURIComponent(token)}`).then((r) => r.data),
  publicRespond: (token, payload) => api.post(`/public/quotes/${encodeURIComponent(token)}`, payload).then((r) => r.data),
};

export default quoteService;
